'use client';

import { useTranslations } from 'next-intl';
import type { SignalCategoryType } from '@terra/shared-schemas-orchestrator';
import { SettingsCard } from '../../settings/SettingsCard';
import { SettingsSection } from '../../settings/SettingsSection';
import { SignalCategoriesContent } from '../../settings/testing-scope/SignalCategoriesContent';
import { INTERNAL_NETWORK_SIGNAL_CATEGORIES } from '../../settings/testing-scope/signal-category-scope';

export type InternalNetworkSignalCategoriesSectionProps = {
  signalCategoriesInScope: SignalCategoryType[];
  onSignalCategoriesChange: (categories: SignalCategoryType[]) => void;
  isReadOnly?: boolean;
  hideHeader?: boolean;
  tableMaxHeight?: string;
};

export function InternalNetworkSignalCategoriesSection({
  signalCategoriesInScope,
  onSignalCategoriesChange,
  isReadOnly,
  hideHeader,
  tableMaxHeight,
}: InternalNetworkSignalCategoriesSectionProps) {
  const t = useTranslations('designSystem.networkSettings.signalCategories');
  const card = (
    <SettingsCard>
      <SignalCategoriesContent
        targetType="INTERNAL_NETWORK"
        signalCategoriesInScope={signalCategoriesInScope}
        onSignalCategoriesChange={onSignalCategoriesChange}
        isReadOnly={isReadOnly}
        tableMaxHeight={tableMaxHeight}
      />
    </SettingsCard>
  );

  if (hideHeader) {
    return card;
  }

  return (
    <SettingsSection
      title={`${t('title')} (${INTERNAL_NETWORK_SIGNAL_CATEGORIES.length})`}
      description={t('description')}
    >
      {card}
    </SettingsSection>
  );
}
